export default {"src":"/_next/static/media/strat.32eea3ba.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};